import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { classNames } from '../../../util/helpers'

import styles from './Banner.module.scss'

const getStylesByType = type => {
  switch (type) {
    case 'warning':
      return styles.warning
    case 'danger':
      return styles.danger
    default:
      return {}
  }
}

const Banner = ({ midasIcon, faIcon, type, text }) => (
  <div className={`${styles.Banner} ${getStylesByType(type)}`}>
    <Box type={type} noPadding>
      <div className={styles.container}>
        <div className={styles.iconAndText}>
          {midasIcon && (
            <i className={classNames(midas.icon, midas[midasIcon])} />
          )}
          {faIcon && (
            <FontAwesomeIcon className={styles.faIcon} icon={faIcon} />
          )}
          <div className={styles.text}>{text}</div>
        </div>
      </div>
    </Box>
  </div>
)

Banner.propTypes = {
  midasIcon: PropTypes.string,
  faIcon: PropTypes.object,
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

Banner.defaultProps = {
  midasIcon: null,
  faIcon: null,
}
export default Banner
